import { USER_TYPES } from "../constants";

export default function userIsLoggedIn(user) {
  if (!user) {
    return false;
  }

  return [USER_TYPES.CLASSROOM_TEACHER.id, USER_TYPES.FAMILY.id].includes(
    user.userTypeId,
  );
}
